export default "__VITE_ASSET__CAlBp4Ty__"